<template>
<!-- 品牌客户 -->
    <div>
        <!-- 图片 -->
        <div class="topImg">
            <span>
                合作伙伴
            </span>
        </div>
        <div class="partner">
            <div class="allTitle">
                <p>品牌客户</p>
                <div>感谢客户的信任与支持</div>
            </div>
            <div class="partnerContent">
                <div class="logOne">
                    <!-- <div><img loading="lazy" src="@/assets/img/brandCustomers/logo01.jpg"> </div> -->
                    <el-tooltip class="item" effect="light" placement="top">
                        <div slot="content" style="font-size:1rem;line-height:1.5rem;">
                            上海万位数字技术有限公司是全领域物联网位置服务商。<br/>通过人工智能、云计算、大数据等技术，实现位置大数据从采集、<br/>
                            传输、存储、计算、分析、展现到优化的服务闭环，面向个人、家庭、<br/>行业和公共提供完整的端（采集终端）到端（展示终端）的一体化服务。
                        </div>
                        <div><img loading="lazy" src="@/assets/img/brandCustomers/logo02.jpg"> </div>
                    </el-tooltip>    
                    <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="top">
                        <div slot="content" style="font-size:1rem;line-height:1.5rem;">
                            英国GLR贸易是一家英国本土的物流公司，该公司拥有自有的运输航班、<br/>国际航运和公路运输网络，先进的运输设备和专业团队，可以为客户提供<br/>
                            供应链管理、仓储、分销等综合服务。公司致力于提供可靠和高效的物流<br/>解决方案，帮助客户降低运输成本、提升物流效率。
                        </div>
                        <div><img loading="lazy" src="@/assets/img/brandCustomers/logo03.jpg"> </div>
                    </el-tooltip>
                    <!-- <div><img loading="lazy" src="@/assets/img/brandCustomers/logo04.jpg"> </div> -->
                </div>
                <div class="logTwo">
                    <!-- <div><img loading="lazy" src="@/assets/img/brandCustomers/logo05.jpg"> </div> -->
                    <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="top">
                        <div slot="content" style="font-size:1rem;line-height:1.5rem;">
                            香港勒丰贸易是一家立足于电商 ，专注汽车后市场领域的销售额过亿的品牌卖家。<br/>公司拥有完整的、专业的运营推广团队和与多类商品厂商合作的经验，致力于为消费者<br/>
                            提供高品质、独特的跨境购物体验，在中国与欧美国家间构建更有效的贸易信息体系。
                        </div>
                        <div class="lefeng">勒丰贸易</div>
                    </el-tooltip>
                    <el-tooltip class="item" effect="light" content="Top Center 提示文字" placement="top">
                        <div slot="content" style="font-size:1rem;line-height:1.5rem;">
                            国内著名H公司，是一家围绕原创IP打造动画、漫画、游戏和小说<br/>等产品的二次元文化互联网企业，致力于技术研发、探索前沿科技，<br/>
                            在卡通渲染、人工智能、云游戏技术等领域积累了先进的技术能力，<br/>并在美国、加拿大、日本等国家和地区进行全球化布局。
                        </div>
                        <div class="h">H</div>
                    </el-tooltip>
                    <!-- <img loading="lazy" src="@/assets/img/brandCustomers/logo06.jpg"> -->
                    <!-- <img loading="lazy" src="@/assets/img/brandCustomers/logo07.jpg"> -->
                    <!-- <div><img loading="lazy" src="@/assets/img/brandCustomers/logo08.jpg"> </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: 'YinshiOffcialwebsiteBrandCustomers',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        ...mapMutations(['GoTop']),
    },    
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.GoTop()
    }
};
</script>

<style lang="scss" scoped>
// 顶部图片
.topImg{
    background: url(../assets/img/brandCustomers/pingpaikehu.jpg);
}
// 合作伙伴
.partner{
    padding:70px 270px;
    // 标题
    .allTitle div{
        margin-top: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: center;
        color: #c6c6c6;
    }
    // 内容
    .partnerContent{
        .contentClass{
            font-size: 18px;
        }
        .logOne,.logTwo{
            display: flex;
            justify-content: space-evenly;
            flex-wrap: wrap;
            div{
                width: 300px;
                height: 200px;
                background: #c6c6c6;
                border:1px solid rgb(255, 255, 255);
                box-shadow: 0px 0px 4px 0px #e0e0e0; 
                transition:.2s;
                img{
                    height: 100%;
                    width: 100%;
                    transition: .3s;
                    cursor: pointer;
                }
            }
            div:hover{
                box-shadow: 0px 0px 0px 0px #e0e0e0; 
                border:1px solid #B8CEFF;
            }
            .lefeng,.h{
                    background: #d1ae9d;
                    border:1px solid transparent;
                    display: flex;
                    align-content: center;
                    justify-content: center;
                    flex-wrap: wrap;
                    color: #fff;
                    font-size: 30px;
                    cursor: pointer;
            }
            .h{
                background: #bc9edd;
            }
        }
        .logOne{
            margin-top: 30px;
        }
        .logTwo{
            margin-top: 50px;
        }
        
    }
}
</style>